module.exports = __webpack_public_path__ + "img/aws.67bacf3e.svg";